/**
 * Whether a product's SKU may be published as a fact (structured data, the
 * PDP SKU row, analytics payloads).
 *
 * A missing SKU is null: the API nulls a value it cannot serialize (product
 * 1630's raw "NaN" on 2026-10-12), and graphqlPartialData keeps the product
 * with that field null. Zero (stored on product 2445 in the 2026-09-13
 * snapshot) is no stock number either. Neither is a fact, so both are
 * omitted, never replaced: in
 * particular never by the product id, which is a different identifier (GA4
 * item_id, Meta content_ids and the Merchant g:id already carry it).
 *
 * Any other value is published as it is, so real codes keep their exact text.
 */
export const isPublishableSku = (value: unknown): boolean => {
  if (typeof value === "number") return Number.isFinite(value) && value !== 0;
  if (typeof value !== "string") return false;
  const text = value.trim();
  return !!text && !/^[+-]?0+(?:\.0+)?$/.test(text) && !/^nan$/i.test(text);
};
